// extracted by mini-css-extract-plugin
export default {"icon":"SearchInput_icon__QHl5D","spinner":"SearchInput_spinner__cn4VJ"};